export default __webpack_public_path__ + "static/media/pgmico(17).97392512.png";